import type { DependencyConfidenceMap } from '../../../../shared/model-typings/projectdependencyconfidence';
import useRevisionDependencyConfidence from './useGetRevisionDependencyConfidence';

/**
 * Helper hook for fetching the confidence of the dependencies of a user's revision.
 * @param parentLocator - The revision locator of the user's revision.
 * @param dependencyLocator - The locator of a dependency of that revision
 * @returns A query for the confidence of the revision's dependencies.
 */
export function useGetDependencyConfidence(parentLocator: string, dependencyLocator: string) {
  const { data } = useRevisionDependencyConfidence(parentLocator);
  const confidenceMap = data?.confidences ?? {} as DependencyConfidenceMap;
  return confidenceMap[dependencyLocator] ?? null;
}
